import React from 'react';
import { GoalHierarchyItemToRender } from './types';
import classNames from 'classnames';
import { Theme } from '../../../../../../../theme';
import { GoalInlineLabels } from '../GoalInlineLabels';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';
import { useSelectedGoal } from '../../useSelectedGoal';
import { Link } from '../../../../../../../Router';
import './GoalHierarchy.css';

type Props = {
  goal: GoalHierarchyItemToRender;
  currentGoalId: string;
  onLinkClick?: () => void;
};

export const GoalHierarchyItem: React.FC<Props> = ({
  goal,
  currentGoalId,
  onLinkClick,
}) => {
  const { getGoalRouteById } = useSelectedGoal();
  const highlight = currentGoalId === goal.id;

  return (
    <div
      className={classNames(
        `goal-hierarchy-item d-flex align-items-center gap-1 py-2 fs-5 text-nowrap`,
        {
          highlight,
        },
      )}
      style={{
        paddingLeft: `${goal.level * 1}rem`,
      }}>
      <FlairIcon
        icon="phosphor-caret-right"
        size="sm"
        style={{ color: Theme.color.blue3, flexShrink: 0 }}
      />
      {highlight ? (
        <span className="text-truncate" title={goal.name}>
          {goal.name}
        </span>
      ) : (
        <Link
          className="text-truncate"
          title={goal.name}
          to={getGoalRouteById({ id: goal.id, type: goal.type })}
          onClick={onLinkClick}>
          {goal.name}
        </Link>
      )}
      <GoalInlineLabels
        goalType={goal.type}
        goalEmployee={goal.employee}
        goalTeam={goal.team}
      />
    </div>
  );
};
